import {
  c98img,
  clipicon,
  collectioncardimg,
  collectionimg1,
  connectbtnimg,
  innerimg,
  maskimg,
  mintimg,
  mintimg1,
  mintimg2,
  mintimg3,
  textBox2,
  video3,
} from "assets";
import NavbarComp from "components/homeCom/navbar";
import React, { useState } from "react";
import {
  CardInnerDiv,
  CardWrapper,
  MainSection,
  Message,
  MessageDiv,
  MobileCardWrapper,
  Name,
  TextBoxDiv,
  TextDiv,
} from "./elements";
import { Image } from "react-bootstrap";
import { MainCol, MainContainer, MainRow } from "components/common";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { useWalletConnectClient } from "services/walletServices";
import { Modal } from "antd";
import ConnectModal from "components/common/modal/connectModel/connectModal";
const MyNft = ({ userIds }) => {
  console.log("USERR", userIds);
  const { account, web3Provider } = useWalletConnectClient();
  const [showModal, setShowModal] = useState(false);

  const flag = true;
  const showConnectModal = () => {
    setShowModal(true);
  };

  const data = [
    {
      name: "NFT ID",
      value: "id",
    },
    {
      name: "Name",
      value: "Element Legend",
    },
    {
      name: "Trait",
      value: "Golden",
    },
    {
      name: "Equippable",
      value: "Shoes",
    },
  ];
  return (
    <MainSection>
      <Modal
        open={showModal}
        centered
        onOk={() => setShowModal(false)}
        onCancel={() => setShowModal(false)}
        width={714}
      >
        <ConnectModal closeModel={() => setShowModal(false)} />
      </Modal>
      <NavbarComp />{" "}
      <div className="main-div">
        <TextBoxDiv>
          <Image className="" src={textBox2} />
          <div>
            <h1 className="inner-text">
              My <span>NFTS</span>
            </h1>
          </div>
        </TextBoxDiv>

        <MainContainer fluid>
          <div className="carddiv">
            <MainRow>
              {!web3Provider && !account ? (
                <>
                  <MessageDiv>
                    <p>Please connect your C98 Wallet or WalletConnect</p>
                    <div
                      className="register-btn-div"
                      onClick={showConnectModal}
                    >
                      <Image
                        src={connectbtnimg}
                        alt="button img"
                        className="btn-img"
                      />
                      <h1>
                        <Image src={c98img} />
                        &nbsp;&nbsp; Connect Wallet
                      </h1>
                    </div>
                  </MessageDiv>
                </>
              ) : (
                <>
                  {userIds.length === 0 ? (
                    <Message>
                      No Nfts <span>Found!</span>
                    </Message>
                  ) : (
                    <>
                      {userIds?.map((item) => (
                        <MainCol lg={4} key={item.id}>
                          <CardWrapper>
                            <Image className="innerimg" src={mintimg} />
                            <CardInnerDiv>
                              <div className="mask1">
                                <Image src={item.image} fluid />
                              </div>
                              <TextDiv>
                                <Name>{"Elemental Legend"}</Name>
                                {item?.attributes.map((item) => (
                                  <>
                                    <div className="content-div">
                                      <h5>{item.name}</h5>
                                      <p>{item.value}</p>
                                    </div>
                                  </>
                                ))}
                              </TextDiv>
                            </CardInnerDiv>
                          </CardWrapper>
                        </MainCol>
                      ))}
                    </>
                  )}
                </>
              )}
            </MainRow>
          </div>

          {/* <div className="mobile-carddiv">
            <Swiper
              navigation={false}
              modules={[Navigation]}
              className="mySwiper"
              slidesPerView={1.3}
              spaceBetween={20}
            >
              {!web3Provider && !account ? (
                <>
                  <MessageDiv>
                    <p>Please Connect Your C98 Wallet</p>
                    <div className="register-btn-div">
                      <Image
                        src={connectbtnimg}
                        alt="button img"
                        className="btn-img"
                      />
                      <h1>
                        <Image src={c98img} />
                        &nbsp;&nbsp; Connect Wallet
                      </h1>
                    </div>
                  </MessageDiv>
                </>
              ) : (
                <>
                  {userIds.length === 0 ? (
                    <Message>
                      No Nfts <span>Found!</span>
                    </Message>
                  ) : (
                    <>
                      {userIds.map((item, index) => (
                        <SwiperSlide key={index}>
                          <MobileCardWrapper>
                            <Image className="innerimg" src={mintimg} />
                            <CardInnerDiv>
                              <div className="innerimg2">
                                <Image
                                  className="inner-img"
                                  src={item.image}
                                  fluid
                                />
                              </div>
                              <TextDiv>
                                <Name>{item.traits}</Name>
                                {data.map((item) => (
                                  <>
                                    <div className="content-div">
                                      <h5>{item.name}</h5>
                                      <p>{item.value}</p>
                                    </div>
                                  </>
                                ))}
                              </TextDiv>
                            </CardInnerDiv>
                          </MobileCardWrapper>
                        </SwiperSlide>
                      ))}
                    </>
                  )}
                </>
              )}
            </Swiper>
          </div> */}
        </MainContainer>
      </div>
    </MainSection>
  );
};

export default MyNft;
